module.exports = __webpack_public_path__ + "static/img/logo-bg-en.8f461e4c.svg";